import { render, staticRenderFns } from "./game-mascot.vue?vue&type=template&id=fb6e435c"
import script from "./game-mascot.vue?vue&type=script&lang=js"
export * from "./game-mascot.vue?vue&type=script&lang=js"
import style0 from "./game-mascot.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game-mascot.vue
// module id = mJhZ
// module chunks = 0